module.exports = __webpack_public_path__ + "img/63ne.d8786784.svg";